import { BCMSRecord, BCMSStateManagerCRUD, useBCMSContext } from "@bcm-dev/bcms-vite";
import AdvancedAlertsPage, { getDefaultPageUI } from "components/pages/AdvancedAlertsPage";
import AdvancedAlertsContent from "components/pages/AdvancedAlertsPage/components/AdvancedAlertsContent";
import Classes from "model";

export default function CaptureNotifiLegacyManage(props) {
    const globalController = useBCMSContext();
    BCMSRecord.globalControllerFor(Classes, globalController);

    const ui = BCMSStateManagerCRUD.init(getDefaultPageUI())
    // Sets the component to be used for the content
    .update([ "content" ], AdvancedAlertsContent)
    .submit();
    
    return <AdvancedAlertsPage ui={ ui } />
}